var render = function () {
  var _vm$collection$name, _vm$collection$name2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "CollectionList",
      "extra-items": _vm.isEditing ? [{
        text: (_vm$collection$name = _vm.collection.name) !== null && _vm$collection$name !== void 0 ? _vm$collection$name : '',
        to: 'CollectionItemList',
        params: _vm.$route.params.id
      }, '編輯項目'] : [{
        text: (_vm$collection$name2 = _vm.collection.name) !== null && _vm$collection$name2 !== void 0 ? _vm$collection$name2 : '',
        to: 'CollectionItemList',
        params: _vm.$route.params.id
      }, '新增項目']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.isEditing ? "編輯項目" : "新增項目") + " - " + _vm._s(_vm.collection.name))]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "排序"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: _vm.item.order,
      callback: function callback($$v) {
        _vm.$set(_vm.item, "order", $$v);
      },
      expression: "item.order"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.item.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.item, "is_enabled", $$v);
      },
      expression: "item.is_enabled"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分類"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.item.type,
      callback: function callback($$v) {
        _vm.$set(_vm.item, "type", $$v);
      },
      expression: "item.type"
    }
  })], 1), _vm.isBranchVisible ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.disabledBranchSelect
    },
    on: {
      "input": _vm.branchChange
    },
    model: {
      value: _vm.item.select_branch,
      callback: function callback($$v) {
        _vm.$set(_vm.item, "select_branch", $$v);
      },
      expression: "item.select_branch"
    }
  })], 1) : _vm._e(), _c('DynamicFormDashboard', {
    ref: "dynamicForm",
    attrs: {
      "input-subjects": _vm.collection.config.fields
    },
    model: {
      value: _vm.inputForm,
      callback: function callback($$v) {
        _vm.inputForm = $$v;
      },
      expression: "inputForm"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)])])], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }